export interface IVehicleTaxConstants {
  petrol: ITaxRate[];
  diesel: ITaxRate[];
  electric: ITaxRate[];
  noselection: ITaxRate[];
  other: ITaxRate[];
}

interface ITaxRate {
  lowerLimitKg: number;
  upperLimitKg: number;
  euro3TaxSek: number;
}

export const VehicleTaxConstants: IVehicleTaxConstants = {
  petrol: [
    { lowerLimitKg: 0, upperLimitKg: 900, euro3TaxSek: 913 },
    { lowerLimitKg: 901, upperLimitKg: 1000, euro3TaxSek: 1129 },
    { lowerLimitKg: 1001, upperLimitKg: 1100, euro3TaxSek: 1343 },
    { lowerLimitKg: 1101, upperLimitKg: 1200, euro3TaxSek: 1557 },
    { lowerLimitKg: 1201, upperLimitKg: 1300, euro3TaxSek: 1771 },
    { lowerLimitKg: 1301, upperLimitKg: 1400, euro3TaxSek: 1985 },
    { lowerLimitKg: 1401, upperLimitKg: 1500, euro3TaxSek: 2199 },
    { lowerLimitKg: 1501, upperLimitKg: 1600, euro3TaxSek: 2413 },
    { lowerLimitKg: 1601, upperLimitKg: 1700, euro3TaxSek: 2627 },
    { lowerLimitKg: 1701, upperLimitKg: 1800, euro3TaxSek: 2841 },
    { lowerLimitKg: 1801, upperLimitKg: 1900, euro3TaxSek: 3055 },
    { lowerLimitKg: 1901, upperLimitKg: 2000, euro3TaxSek: 3269 },
    { lowerLimitKg: 2001, upperLimitKg: 2100, euro3TaxSek: 3483 },
    { lowerLimitKg: 2101, upperLimitKg: 2200, euro3TaxSek: 3697 },
    { lowerLimitKg: 2201, upperLimitKg: 2300, euro3TaxSek: 3911 },
    { lowerLimitKg: 2301, upperLimitKg: 2400, euro3TaxSek: 4125 },
    { lowerLimitKg: 2401, upperLimitKg: 2500, euro3TaxSek: 4339 },
    { lowerLimitKg: 2501, upperLimitKg: 2600, euro3TaxSek: 4553 },
    { lowerLimitKg: 2601, upperLimitKg: 2700, euro3TaxSek: 4767 },
    { lowerLimitKg: 2701, upperLimitKg: 2800, euro3TaxSek: 4981 },
    { lowerLimitKg: 2801, upperLimitKg: 2900, euro3TaxSek: 5195 },
    { lowerLimitKg: 2901, upperLimitKg: 3000, euro3TaxSek: 5409 },
    { lowerLimitKg: 3001, upperLimitKg: 3100, euro3TaxSek: 5623 },
    { lowerLimitKg: 3101, upperLimitKg: 3200, euro3TaxSek: 5837 },
    { lowerLimitKg: 3201, upperLimitKg: 3300, euro3TaxSek: 6051 },
    { lowerLimitKg: 3301, upperLimitKg: 3400, euro3TaxSek: 6265 },
    { lowerLimitKg: 3401, upperLimitKg: 3500, euro3TaxSek: 6479 },
  ],
  diesel: [
    { lowerLimitKg: 0, upperLimitKg: 900, euro3TaxSek: 2298 },
    { lowerLimitKg: 901, upperLimitKg: 1000, euro3TaxSek: 2863 },
    { lowerLimitKg: 1001, upperLimitKg: 1100, euro3TaxSek: 3427 },
    { lowerLimitKg: 1101, upperLimitKg: 1200, euro3TaxSek: 3991 },
    { lowerLimitKg: 1201, upperLimitKg: 1300, euro3TaxSek: 4555 },
    { lowerLimitKg: 1301, upperLimitKg: 1400, euro3TaxSek: 5119 },
    { lowerLimitKg: 1401, upperLimitKg: 1500, euro3TaxSek: 5683 },
    { lowerLimitKg: 1501, upperLimitKg: 1600, euro3TaxSek: 6247 },
    { lowerLimitKg: 1601, upperLimitKg: 1700, euro3TaxSek: 6811 },
    { lowerLimitKg: 1701, upperLimitKg: 1800, euro3TaxSek: 7375 },
    { lowerLimitKg: 1801, upperLimitKg: 1900, euro3TaxSek: 7939 },
    { lowerLimitKg: 1901, upperLimitKg: 2000, euro3TaxSek: 8503 },
    { lowerLimitKg: 2001, upperLimitKg: 2100, euro3TaxSek: 9067 },
    { lowerLimitKg: 2101, upperLimitKg: 2200, euro3TaxSek: 9631 },
    { lowerLimitKg: 2201, upperLimitKg: 2300, euro3TaxSek: 10195 },
    { lowerLimitKg: 2301, upperLimitKg: 2400, euro3TaxSek: 10759 },
    { lowerLimitKg: 2401, upperLimitKg: 2500, euro3TaxSek: 11323 },
    { lowerLimitKg: 2501, upperLimitKg: 2600, euro3TaxSek: 11887 },
    { lowerLimitKg: 2601, upperLimitKg: 2700, euro3TaxSek: 12451 },
    { lowerLimitKg: 2701, upperLimitKg: 2800, euro3TaxSek: 13015 },
    { lowerLimitKg: 2801, upperLimitKg: 2900, euro3TaxSek: 13579 },
    { lowerLimitKg: 2901, upperLimitKg: 3000, euro3TaxSek: 14143 },
    { lowerLimitKg: 3001, upperLimitKg: 3100, euro3TaxSek: 14707 },
    { lowerLimitKg: 3101, upperLimitKg: 3200, euro3TaxSek: 15271 },
    { lowerLimitKg: 3201, upperLimitKg: 3300, euro3TaxSek: 15835 },
    { lowerLimitKg: 3301, upperLimitKg: 3400, euro3TaxSek: 16399 },
    { lowerLimitKg: 3401, upperLimitKg: 3500, euro3TaxSek: 16963 },
  ],
  noselection: [],
  electric: [],
  other: [],
};
